import React from "react";
import CategoryDescription from "../categoryDescription/categoryDescription.js";
import CategoryImages from "../categoryImages/categoryImages.js";
import { CategoryOneTimeOffers } from "../categoryOneTimeOffers/categoryOneTimeOffers.js";
import CategoryPrices from "../categoryPrices/categoryPrices.js";
import CategoryTitle from "../categoryTitle/categoryTitle.js";
import "./style.css";
import CategoryPromotions from "../CategoryPromotions/CategoryPromotions.js";
import FormCategory from "../FormCategory/FormCategory.js";
export default function Category(props) {
    const perImageOffers = props.category.offers.filter((offer) => offer.forEveryImage === true);
    if (props.galleryType === "form") {
        return (React.createElement(FormCategory, { category: props.category, categoryIndex: props.categoryIndex }));
    }
    if (props.category.images.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("section", { className: "category-section" },
        React.createElement(CategoryTitle, { title: props.category.name }),
        React.createElement(CategoryDescription, { text: props.category.description }),
        React.createElement(CategoryPrices, { offers: props.category.offers }),
        React.createElement(CategoryOneTimeOffers, { offers: props.category.offers.filter((offer) => offer.forEveryImage == false && offer.offerType !== "promotion"), categoryIndex: props.categoryIndex }),
        React.createElement(CategoryPromotions, { promotions: props.category.offers.filter((offer) => offer.forEveryImage === false && offer.offerType === "promotion") }),
        React.createElement(CategoryImages, { images: props.category.images, offers: perImageOffers })));
}
